(function () {
  if (window.__GRP_TOOLKIT_UPSELL_BOUND__) return;
  window.__GRP_TOOLKIT_UPSELL_BOUND__ = true;

  // ---------- helpers ----------
  function closest(el, selector) {
    while (el && el.nodeType === 1) {
      if (el.matches(selector)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function parseAddRequestId(body) {
    try {
      if (!body) return null;

      // JSON string
      if (typeof body === "string") {
        // could be JSON or urlencoded
        try {
          const j = JSON.parse(body);
          if (j && typeof j === "object" && j.id) return String(j.id);
        } catch (_) {
          const usp = new URLSearchParams(body);
          const id = usp.get("id");
          return id ? String(id) : null;
        }
      }

      // FormData
      if (typeof FormData !== "undefined" && body instanceof FormData) {
        const id = body.get("id");
        return id ? String(id) : null;
      }

      // URLSearchParams
      if (typeof URLSearchParams !== "undefined" && body instanceof URLSearchParams) {
        const id = body.get("id");
        return id ? String(id) : null;
      }

      // object payload
      if (typeof body === "object" && body.id) return String(body.id);
    } catch (_) {}

    return null;
  }

  async function addToCartToolkit(variantId) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-GRP-Toolkit-Upsell": "1", // marker so our fetch hook ignores this call
      },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(text || "Toolkit add failed");
    }
    return res.json();
  }

  // ---------- UI sync (preview/media) ----------
  function syncToolkitMedia(upsell) {
    if (!upsell) return;

    const toggle = upsell.querySelector("[data-toolkit-toggle]");
    const imgUrl = upsell.getAttribute("data-toolkit-image-url") || "";
    const imgAlt = upsell.getAttribute("data-toolkit-image-alt") || "";
    const productUrl = upsell.getAttribute("data-toolkit-product-url") || "#";

    const productInfo = upsell.closest("product-info") || document;
    const mediaBox = productInfo.querySelector("[data-toolkit-media]");
    if (!mediaBox) return;

    const link = mediaBox.querySelector("[data-toolkit-media-link]");
    const img = mediaBox.querySelector("[data-toolkit-media-img]");
    if (!link || !img) return;

    if (!toggle || !toggle.checked) {
      mediaBox.classList.add("is-hidden");
      return;
    }

    if (imgUrl) img.src = imgUrl;
    img.alt = imgAlt || "Tool kit";
    link.href = productUrl || "#";
    mediaBox.classList.remove("is-hidden");
  }

  function bindUpsell(upsell) {
    if (!upsell || upsell.dataset.grpBound === "1") return;
    upsell.dataset.grpBound = "1";

    const toggle = upsell.querySelector("[data-toolkit-toggle]");
    const preview = upsell.querySelector("[data-toolkit-preview]");

    function syncPreview() {
      if (!toggle || !preview) return;
      preview.hidden = !toggle.checked;
    }

    syncPreview();
    syncToolkitMedia(upsell);

    if (toggle) {
      toggle.addEventListener("change", function () {
        syncPreview();
        syncToolkitMedia(upsell);
      });
    }
  }

  function initOnPage() {
    document.querySelectorAll("[data-toolkit-upsell]").forEach(bindUpsell);
  }

  initOnPage();
  document.addEventListener("shopify:section:load", initOnPage);

  // ---------- add toolkit AFTER Minimog adds main ----------
  const pending = {
    ts: 0,
    mainVariantId: null,
    toolkitVariantId: null,
  };

  function setPending(mainVariantId, toolkitVariantId) {
    pending.ts = Date.now();
    pending.mainVariantId = String(mainVariantId || "");
    pending.toolkitVariantId = String(toolkitVariantId || "");
  }

  function clearPending() {
    pending.ts = 0;
    pending.mainVariantId = null;
    pending.toolkitVariantId = null;
  }

  // Capture submit to decide whether we should add a toolkit for this add-to-cart
  document.addEventListener(
    "submit",
    function (e) {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.matches('form[data-type="add-to-cart-form"]')) return;

      const wrapper = closest(form, "product-info") || document;
      const upsell =
        wrapper.querySelector("[data-toolkit-upsell]") ||
        document.querySelector("[data-toolkit-upsell]");

      if (!upsell) return;

      const toggle = upsell.querySelector("[data-toolkit-toggle]");
      const toolkitVariantId = upsell.getAttribute("data-toolkit-variant-id");

      if (!toggle || !toggle.checked) return;
      if (!toolkitVariantId) return;

      // Minimog often keeps the id input disabled; read it directly anyway
      const idInput = form.querySelector('input[name="id"]');
      const mainVariantId = idInput ? idInput.value : "";

      if (!mainVariantId) return;

      // Only one pending at a time; user action is sequential
      setPending(mainVariantId, toolkitVariantId);
    },
    true
  );

  // Hook fetch once: when Minimog successfully POSTs /cart/add.js for the MAIN variant,
  // we then add the toolkit once.
  if (!window.__GRP_TOOLKIT_FETCH_WRAPPED__) {
    window.__GRP_TOOLKIT_FETCH_WRAPPED__ = true;

    const _fetch = window.fetch.bind(window);

    window.fetch = async function (input, init) {
      const url = typeof input === "string" ? input : (input && input.url) || "";
      const isCartAdd = url && url.indexOf("/cart/add.js") !== -1;

      // Let the request happen first
      const res = await _fetch(input, init);

      try {
        if (!isCartAdd) return res;

        // Ignore our own toolkit add call
        const hdrs = (init && init.headers) || {};
        const hasMarker =
          (typeof Headers !== "undefined" && hdrs instanceof Headers && hdrs.get("X-GRP-Toolkit-Upsell")) ||
          (hdrs && (hdrs["X-GRP-Toolkit-Upsell"] || hdrs["x-grp-toolkit-upsell"]));

        if (hasMarker) return res;

        // Must be a recent pending action
        const ageMs = Date.now() - (pending.ts || 0);
        if (!pending.toolkitVariantId || !pending.mainVariantId || ageMs > 8000) return res;

        // Must match the MAIN variant id being added in this request
        const body = init && init.body;
        const addedId = parseAddRequestId(body);
        if (!addedId || String(addedId) !== String(pending.mainVariantId)) return res;

        // Only proceed if the main add succeeded
        if (!res || !res.ok) return res;

        // Clear pending BEFORE adding toolkit to avoid re-entrancy
        const tkId = pending.toolkitVariantId;
        clearPending();

        await addToCartToolkit(tkId);

        // Kick the cart UI to refresh (Minimog + your other scripts)
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        document.dispatchEvent(new CustomEvent("cart:updated"));
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh"));
        document.documentElement.dispatchEvent(new CustomEvent("cart:updated"));
      } catch (err) {
        console.error("[GRP Toolkit Upsell]", err);
        // if something goes wrong, don't block normal cart behaviour
        clearPending();
      }

      return res;
    };
  }

  // ---------- show/hide toolkit tab (your kit tabs code relies on [data-toolkit-toggle]) ----------
  document.addEventListener("change", function (e) {
    const toggle =
      e.target && e.target.matches && e.target.matches("[data-toolkit-toggle]") ? e.target : null;
    if (!toggle) return;

    const checked = !!toggle.checked;

    const productInfo = toggle.closest("product-info") || document;
    const kitWrapper = productInfo.querySelector(".kit-wrapper[data-has-toolkit='true']");
    if (!kitWrapper) return;

    const toolkitTab = kitWrapper.querySelector("[data-kit-toolkit-tab]");
    const toolkitPanel = kitWrapper.querySelector("[data-kit-toolkit-panel]");
    if (!toolkitTab || !toolkitPanel) return;

    if (checked) {
      toolkitTab.classList.remove("is-hidden");
      if (kitWrapper.querySelector("[data-kit-tabs]")) toolkitTab.click();
      else toolkitPanel.style.display = "";
    } else {
      toolkitTab.classList.add("is-hidden");
      toolkitPanel.style.display = "none";

      const active = kitWrapper.querySelector(".kit-tab-btn.is-active");
      if (active && active.getAttribute("data-kit-tab-btn") === "toolkit") {
        const fallback =
          kitWrapper.querySelector('[data-kit-tab-btn="includes"]') ||
          kitWrapper.querySelector('[data-kit-tab-btn="summary"]');
        if (fallback) fallback.click();
      }
    }

    const upsell = toggle.closest("[data-toolkit-upsell]");
    if (upsell) syncToolkitMedia(upsell);
  });
})();